/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import isEmpty from 'lodash/isEmpty';
import moment from 'moment';

export const getFarthestAvailabilityDate = (farthestByTour, tourIdList) => {
    if (isEmpty(farthestByTour) || isEmpty(tourIdList)) {
        return null;
    }

    let farthestDate = moment();
    let farthestInPast = true;
    Object.keys(farthestByTour).forEach((tourId) => {
        if (tourIdList.includes(tourId)) {
            const tourDate = moment(farthestByTour[tourId], 'YYYY-MM-DD');
            if (farthestDate.isBefore(tourDate)) {
                farthestDate = tourDate;
                farthestInPast = false;
            }
        }
    });

    if (farthestInPast) {
        return null;
    }

    return farthestDate;
};
